import { createAction } from '@reduxjs/toolkit'

import {
  NavigationOptions,
  RouteKey,
  RouteParams,
} from '../types/routing.types'

export const navigateToRoute = createAction<{
  routeKey: RouteKey
  params?: RouteParams[RouteKey]
  options?: NavigationOptions
}>('NAVIGATE_TO_ROUTE')

export const checkRoute = createAction<{
  skipValidation?: boolean
}>('CHECK_ROUTE')

export const redirectRoute = createAction<{
  path: string
  hardRedirect?: boolean
}>('REDIRECT')
